import React from "react";
import {Box, Grid, Tab} from "@material-ui/core";
import MyClipsPaginationBar from "../containers/MyClipsPaginationBar";
import SendToForgeDialog from "../components/SendToForgeDialog";
import ForgeSnackbar from "../containers/ForgeSnackbar";
import WithAuth from "../containers/WithAuth";
import {TabContext, TabList, TabPanel} from "@material-ui/lab";
import {inject, observer} from "mobx-react";
import CustomClipsPaginationBar from "../containers/CustomClipsPaginationBar";
import ImageClip from "../components/ImageClip";
import ClipActions from "../components/ClipActions";
import CustomClipActions from "../components/CustomClipActions";

const TAB_MAPPING = {
  MY_CLIPS: "1",
  MY_CUSTOM_CLIPS: "2",
  ALL_CUSTOM_CLIPS: "3"
};

class Clips extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTab: "1"
    };

    this.changeSelectedTab = this.changeSelectedTab.bind(this);
  }

  componentWillMount() {
    const {
      myClipsStore,
      myCustomClipsStore,
      allCustomClipsStore,
      authStore
    } = this.props;
    const params = new URLSearchParams(this.props.location.search);
    const requestedTab = params.get("selectedTab");
    if (requestedTab && TAB_MAPPING[requestedTab]) {
      this.setState({selectedTab: TAB_MAPPING[requestedTab]});
    }

    myClipsStore.initialize({videosPerPage: 12});
    myCustomClipsStore.initialize({clipsPerPage: 12});

    if (authStore.canViewAllCustomClips) {
      allCustomClipsStore.initialize({clipsPerPage: 12});
    }
  }

  componentWillUnmount() {
    const {
      myClipsStore,
      myCustomClipsStore,
      allCustomClipsStore,
      authStore
    } = this.props;
    myClipsStore.dispose();
    myCustomClipsStore.dispose();

    if (authStore.canViewAllCustomClips) {
      allCustomClipsStore.dispose();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {myClipsStore, sendToForgeDialogStore} = this.props;
    sendToForgeDialogStore.clipsToSearch = myClipsStore.videos;
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  changeSelectedTab(selectedTab) {
    this.setState({selectedTab});
  }

  render() {
    const {
      myClipsStore,
      myCustomClipsStore,
      allCustomClipsStore,
      authStore
    } = this.props;

    return (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TabContext value={this.state.selectedTab}>
              <Box
                  sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    padding: "4px 24px 0 24px"
                  }}
              >
                <TabList onChange={(e, v) => this.changeSelectedTab(v)}>
                  {[
                    <Tab key="1" label="My Clips" value="1"/>,
                    <Tab key="2" label="My Custom Clips" value="2"/>,
                    authStore.canViewAllCustomClips && <Tab key="3" label="All Custom Clips" value="3"/>
                  ].filter(Boolean)}
                </TabList>
              </Box>
              <TabPanel value="1">
                <Grid container spacing={2}>
                  <Grid item xs={12} style={{padding: "0"}}>
                    <MyClipsPaginationBar/>
                  </Grid>
                  {myClipsStore.videos.map((video, index) => (
                      <Grid key={index} item xs={12} sm={6} md={4} lg={2}>
                        <ImageClip video={video} actionsComponent={ClipActions}/>
                      </Grid>
                  ))}
                </Grid>
              </TabPanel>
              <TabPanel value="2">
                <Grid container spacing={2}>
                  <Grid item xs={12} style={{padding: "0"}}>
                    <CustomClipsPaginationBar
                        customClipsStore={myCustomClipsStore}
                        showFilters={true}
                    />
                  </Grid>
                  {myCustomClipsStore.clips.map((video, index) => {
                    video.videoUri = video.url;
                    video.title = video.description;
                    return (
                        <Grid key={index} item xs={12} sm={6} md={4} lg={2}>
                          <ImageClip
                              video={video}
                              actionsComponent={CustomClipActions}
                          />
                        </Grid>
                    );
                  })}
                </Grid>
              </TabPanel>
              {authStore.canViewAllCustomClips && (
                  <TabPanel value="3">
                    <Grid container spacing={2}>
                      <Grid item xs={12} style={{padding: "0"}}>
                        <CustomClipsPaginationBar
                            customClipsStore={allCustomClipsStore}
                            showFilters={true}
                        />
                      </Grid>
                      {allCustomClipsStore.clips.map((video, index) => {
                        video.videoUri = video.url;
                        video.title = video.description;
                        return (
                            <Grid key={index} item xs={12} sm={6} md={4} lg={2}>
                              <ImageClip
                                  video={video}
                                  actionsComponent={CustomClipActions}
                              />
                            </Grid>
                        );
                      })}
                    </Grid>
                  </TabPanel>
              )}
            </TabContext>
          </Grid>
          <ForgeSnackbar/>
          <SendToForgeDialog/>
        </Grid>
    );
  }
}

export default inject(
    "myClipsStore",
    "myCustomClipsStore",
    "allCustomClipsStore",
    "sendToForgeDialogStore",
    "authStore"
)(WithAuth(observer(Clips)));



// WEBPACK FOOTER //
// ./src/pages/Clips.js